import TabGroupBoleto from '@/components/molecules/TabGroupBoleto';
import { BoletoTabs } from '@/data/misc/boleto-tabs';

export default function DenunciasEFraudesPage() {
  return <TabGroupBoleto tab={BoletoTabs['denuncias-e-fraudes'].id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
